export default __webpack_public_path__ + "static/media/976.751762c8.gif";